import { useEffect, useRef } from 'react';
import { useLeafletContext } from './context.js';
export function createControlHook(useElement) {
  return function useLeafletControl(props) {
    var context = useLeafletContext();
    var elementRef = useElement(props, context);
    var instance = elementRef.current.instance;
    var positionRef = useRef(props.position);
    var position = props.position;
    useEffect(function addControl() {
      instance.addTo(context.map);
      return function removeControl() {
        instance.remove();
      };
    }, [context.map, instance]);
    useEffect(function updateControl() {
      if (position != null && position !== positionRef.current) {
        instance.setPosition(position);
        positionRef.current = position;
      }
    }, [instance, position]);
    return elementRef;
  };
}